import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import panelsService from "./PanelsService";

const initialState = {
    panels: [],
    panel: null,
    search: null,
    isError: false,
    isSuccess: false,
    isLodaing: false,
    massage: "",
};

export const getAllPanels = createAsyncThunk(
    "panels/get",
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await panelsService.getAllPanels(token);
        } catch (error) {
            const massage = error.message;

            return thunkAPI.rejectWithValue(massage);
        }
    }
);

// get single  panels
// export const getSinglePanel = createAsyncThunk(
//   "panels/single",
//   async (id, thunkAPI) => {
//     try {
//       const token = thunkAPI.getState().auth.mainUser.data.token;
//       return await panelsService.getSinglePanel(id, token);
//     } catch (error) {
//       const massage =
//         (error.response &&
//           error.response.data &&
//           error.response.data.massage) ||
//         error.response.data.error ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(massage);
//     }
//   }
// );

// post panels
export const postAllPanels = createAsyncThunk(
    "panels/post",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await panelsService.postAllPanels(data, token);
        } catch (error) {
            const massage =
                (error.response &&
                    error.response.data &&
                    error.response.data.massage) ||
                error.response.data.error ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const PanelsSearch = createAsyncThunk(
    "panels/search",
    async (searchValue, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await panelsService.PanelsSearch(searchValue, token);
        } catch (error) {
            const massage =
                (error.response &&
                    error.response.data &&
                    error.response.data.massage) ||
                error.response.data.error ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

// update  panels
export const updatePanel = createAsyncThunk(
    "panels/update",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await panelsService.updatePanel(data, token);
        } catch (error) {
            const massage =
                (error.response &&
                    error.response.data &&
                    error.response.data.massage) ||
                error.response.data.error ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

// post panels
export const DeletePanel = createAsyncThunk(
    "panels/post",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await panelsService.deletePanel(id, token);
        } catch (error) {
            const massage =
                (error.response &&
                    error.response.data &&
                    error.response.data.massage) ||
                error.response.data.error ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const panelsSlice = createSlice({
    name: "panels",
    initialState,
    reducers: {
        reset: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isLodaing = false;
            state.massage = "";
        },
        panelSearchAction: (state, action) => {
            state.search = action.payload;
        },
    },
    extraReducers: {
        //getAllPanels Actions
        [getAllPanels.pending]: (state) => {
            state.isLodaing = true;
        },
        [getAllPanels.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.panels = action.payload;
            state.isSuccess = true;
        },
        [getAllPanels.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
            state.panels = null;
        },

        //get single Panels Actions
        // [getSinglePanel.pending]: (state) => {
        //   state.isLodaing = true;
        // },
        // [getSinglePanel.fulfilled]: (state, action) => {
        //   state.isLodaing = false;
        //   state.panel = action.payload;
        //   state.isSuccess = true;
        // },
        // [getSinglePanel.rejected]: (state, action) => {
        //   state.isLodaing = false;
        //   state.isError = true;
        //   state.massage = action.payload;
        //   state.panels = null;
        // },

        //post panels actions  Actions
        [postAllPanels.pending]: (state) => {
            state.isLodaing = true;
        },
        [postAllPanels.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
            state.panels.data.data.push(action.payload.data);
        },
        [postAllPanels.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //post panels actions  Actions
        [PanelsSearch.pending]: (state) => {
            state.isLodaing = true;
        },
        [PanelsSearch.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
            state.panels = action.payload;
        },
        [PanelsSearch.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //update  panels actions  Actions
        [updatePanel.pending]: (state) => {
            state.isLodaing = true;
        },
        [updatePanel.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
            state.panels.data.data.map((item) => {
                if (item.id === action.payload.data.id) {
                    item.title = action.payload.data.title;
                    item.wattage = action.payload.data.wattage;
                    item.description = action.payload.data.description;
                    item.price = action.payload.data.price;
                    item.state_id = action.payload.data.state_id;
                    item.is_default = action.payload.data.is_default;
                    item.image_path = action.payload.data.image_path;
                }
            });
        },
        [updatePanel.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },

        //Delete panel actions  Actions
        [DeletePanel.pending]: (state, action) => {
            state.isLodaing = true;
        },
        [DeletePanel.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isSuccess = true;
            state.panels.data.data = state.panels.data.data.filter(
                (el) => el.id !== action.payload
            );
        },
        [DeletePanel.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isError = true;
            state.massage = action.payload;
        },
    },
});

export const { reset, panelSearchAction } = panelsSlice.actions;
export default panelsSlice.reducer;
